// removed by extract-text-webpack-plugin
module.exports = {"seoHeading":"homepage-module_seoHeading_3LZtD","seoSubHeading":"homepage-module_seoSubHeading_nhxcT"};


//////////////////
// WEBPACK FOOTER
// ./client/components/seoHeadings/themes/homepage.module.css
// module id = 490
// module chunks = 1 3